'use client'

import CategoriesPage from './CategoriesPage'

export default function Home() {
  return <CategoriesPage />
}
